import { render, staticRenderFns } from "./UserVenues.vue?vue&type=template&id=9aaff15a&"
import script from "./UserVenues.vue?vue&type=script&lang=js&"
export * from "./UserVenues.vue?vue&type=script&lang=js&"
import style0 from "./UserVenues.vue?vue&type=style&index=0&id=9aaff15a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports